/* eslint-disable complexity */
import React, { useContext } from 'react';
import { IOfferContext, OfferContext, Variants, getLabelValue } from '@adac-mp/shared';
import { Typography } from '../../index';

interface IOrderSummaryBoxProps {
	isCancelOrder?: boolean;
	variant?: Variants;
	orderNumber: string;
	serviceCatalogName?: string;
	hidePrice?: boolean;
	totalPrice?: string;
	additionalInfo?: {
		title: string;
		label: string;
	};
	itemLabel: string;
	priceLabel?: string;
	style?: React.CSSProperties;
}

export const OrderSummaryBox = ({
	additionalInfo,
	hidePrice,
	isCancelOrder = false,
	itemLabel,
	orderNumber,
	priceLabel,
	serviceCatalogName = undefined,
	style = {},
	totalPrice,
	variant,
}: IOrderSummaryBoxProps) => {
	const { labels } = useContext<IOfferContext>(OfferContext);

	return (
		<div className="bg-gray-700 px-4 py-3.5 rounded-lg w-full mb-5" data-cy="order-summary" style={style}>
			<div className={`flex justify-between ${isCancelOrder && hidePrice ? '' : 'mb-3'}`}>
				<Typography component="p" color="title" size="baseLg" className="flex-1 text-left">
					{itemLabel}
				</Typography>
				<Typography data-cy="order-number" component="div" color="title" size="baseLg" className="text-right">
					{serviceCatalogName && <span className="block font-bold">{serviceCatalogName}</span>}
					{orderNumber}
				</Typography>
			</div>
			{!hidePrice && (
				<div
					className={`flex justify-between ${
						isCancelOrder ? 'items-baseline' : 'items-center'
					} gap-1.5 mb-3 last:mb-0`}>
					<div className="text-left flex-1">
						<Typography component="p" color="title" size="baseLg">
							{priceLabel}
						</Typography>
						{!isCancelOrder && variant === 'dkv' && (
							<Typography component="p" color="text" size="sm">
								Jahresgebühr Mautbox-Abo inkl. Aktivierung und Versand
							</Typography>
						)}
					</div>
					<Typography
						data-cy="order-price"
						component="p"
						color="title"
						size="baseLg"
						className="flex-1 text-right font-bold">
						{totalPrice}
						{isCancelOrder && variant === 'dkv' && (
							<Typography component="p" color="text" size="sm" className="font-normal">
								exkl. Service- und Mautgebühren
							</Typography>
						)}
						{isCancelOrder && variant === 'vignette' && (
							<Typography component="p" color="text" size="sm" className="font-normal">
								{getLabelValue('mp.vat', labels) || 'inkl. MwSt.'}
							</Typography>
						)}
					</Typography>
				</div>
			)}
			{additionalInfo && (
				<div className="flex justify-between items-center gap-1.5">
					<Typography
						data-cy="additional info:title"
						component="p"
						color="title"
						size="baseLg"
						className="flex-1 text-left">
						{additionalInfo.title}
					</Typography>
					<Typography
						data-cy="additional info:label"
						component="p"
						color="title"
						size="baseLg"
						className="flex-1 text-right">
						{additionalInfo.label}
					</Typography>
				</div>
			)}
		</div>
	);
};
